"use client";  // Add this line at the very top

import React from 'react';
import Image from 'next/image';
import Nav from 'react-bootstrap/Nav';
import "./footer.css"
import { useTranslation } from 'react-i18next';
import { useDarkMode } from '../darkModeContext';

const Footer = () => {
    const isDarkMode = useDarkMode();
    let year = new Date().getFullYear();
    const { t } = useTranslation();

    return (
        <footer className="bg-blue-light dark:bg-blue dark:text-white my-0">
            <div className="line-with-text m-0 pt-4 my-0">
                <span><p className='my-0 mx-4'>{t('footer.helpfulSupport')}</p></span>
            </div>
    
            <div className="flex flex-col md:flex-row w-full gap-6 md:gap-10 justify-center items-center md:items-end py-8 md:py-5">
                <Nav.Link href="https://www.alumni-ensta-bretagne.fr" target="_blank" rel="noopener noreferrer">
                    <Image 
                        src="/images/sponsors/ensta_alumni.png" 
                        alt="ENSTA ALumni sponsor logo" 
                        width={400}
                        height={174}
                        className="w-auto h-10 md:h-16 cursor-pointer md:mb-4" 
                        objectFit="contain"
                    />
                </Nav.Link>

                <Nav.Link href="https://www.ensta-bretagne.fr/fr/incubateur-enstartups" target="_blank" rel="noopener noreferrer">
                    <Image 
                        src="/images/sponsors/enstartups.png" 
                        alt="Enstartups sponsor logo" 
                        width={456}
                        height={111}
                        className="w-auto h-9 md:h-12 cursor-pointer md:mb-4" 
                        objectFit="contain"
                    />
                </Nav.Link>

                <Nav.Link href="https://www.rutgerson.se/" target="_blank" rel="noopener noreferrer">
                    <Image 
                        src="/images/sponsors/rutgerson-logo.png" 
                        alt="Rutgerson sponsor logo" 
                        width={456}
                        height={111}
                        className="w-auto h-6 md:h-9 cursor-pointer md:mb-4" 
                        objectFit="contain"
                    />
                </Nav.Link>
            </div>
    
            <div className="footer pt-3 pb-1 px-0 shadow-lg font-montserrat bg-light dark:bg-dark">
                <div className="text-center m-0 md:pl-2 md:pr-5 gap-5 lg:gap-10 w-full d-flex flex flex-col md:flex-row justify-content-between items-center">
        
                    <div className='flex flex-row w-[100vw] justify-left items-end md:items-start'>
                        {/* Logo */}
                        <div className="footer-brand w-[49vw] md:w-1/4 md:w-1/4 font-handlee font-bold italic flex items-end mb-6 md:mb-4 md:mb-0">
                            <a href="/">
                                <Image
                                    src={isDarkMode 
                                        ? '/images/logo/logo-transparent-white contours.png' 
                                        : '/images/logo/logo-transparent-black thick contours.png'}
                                    alt="SoBoo Logo"
                                    width={100} 
                                    height={100}
                                    className="scrolled cursor-pointer"
                                    objectFit="contain"
                                />
                            </a>
                            {/* Location (Top-aligned with NavLinks) */}
                            <div className="w-auto flex md:mt-12 md:mr-6 justify-end items-end">
                                <p className="location text-left mb-0 leading-none text-darkgrey">
                                    {t('footer.location')}
                                </p> 
                            </div>
                        </div>

                        {/* Navigation Links */}
                        <div className="w-[49vw] relative h-[100%] flex flex-col md:mt-8 md:mb-auto md:flex-row items-center justify-end md:justify-center md:space-x-6 mb-0 md:items-center">
                            <a href="/" className="cursor-pointer text-gray-500 block w-[150px] md:w-[200px] mb-4 md:mb-4 m-0 transition-all footer-links text-right md:text-center text-lg leading-none hover:font-bold relative">
                                <span className="invisible font-bold">{t('footer.home')}</span>
                                <span className="absolute inset-0">{t('footer.home')}</span>
                            </a>
                            <a href="/contact" className="cursor-pointer text-gray-500 block w-[150px] md:w-[200px] mb-4 md:mb-4 m-0 transition-all footer-links text-right md:text-center text-lg leading-none hover:font-bold relative">
                                <span className="invisible font-bold">{t('footer.contactUs')}</span>
                                <span className="absolute inset-0">{t('footer.contactUs')}</span>
                            </a>
                        </div>
                    </div>

                </div>
    
                <div className='flex flex-col md:flex-row items-center md:justify-between'>
                    <p className="footer-links text-right mb-0 text-gray-500 pt-2 md:pt-0 pl-6 pr-2">
                        <a 
                            className="copyright hover:font-bold transition-all cursor-pointer"
                            href="https://github.com/Agathe-Coulombier">
                            {t('footer.agathe')}
                        </a>
                    </p> 
                    <p className="copyright text-left mb-0 text-gray-500 pt-1 md:pt-0 pl-6 md:pr-6">© {year} Sail on Bamboo. {t('footer.copyright')}</p> 
                </div>

            </div>
        </footer>
    );
}

export default Footer;
